<template lang="pug">
#Dashboard
  .d-flex.flex-column.align-items-start.mb-2
    h4.title
      | Dashboard
      b-spinner.ml-3(v-if="loading" label="Cargando..." variant="primary")
    nav.breadcrumb-custom
      span Inicio
      span.separator /
      span Dashboard
  //- HeaderCards.mb-3
  MainTable
</template>

<script>
import { mapState, mapWritableState } from 'pinia'
import { mapGetters } from 'vuex'
import HeaderCards from '@/components/Dashboard/HeaderCards.vue'
import MainTable from '@/components/Dashboard/MainTable.vue'
import { useDashboardStore } from '../pinia/views/useDashboardStore'

export default {
  name: 'Dashboard',
  components: {
    HeaderCards,
    MainTable,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { path: '/' },
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    }
  },
  methods: {},
  async created() {
    this.filters.tecnico = null
    this.$nextTick(() => {
      const { user } = JSON.parse(localStorage.getItem('user'))
      const functionalGroups = user.groups.filter(
        (g) => g.name !== 'SILL_USERS'
      )
      const isOnlyTechnician =
        functionalGroups.length === 1 &&
        functionalGroups.some((g) => g.name === 'Técnico')
      if (isOnlyTechnician) {
        this.filters.tecnico = user.id
      }
    })
  },
  computed: {
    ...mapState(useDashboardStore, ['loading']),
    ...mapWritableState(useDashboardStore, ['filters']),
    ...mapGetters('AuthenticationStore', ['user']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '@/style/colors.scss';

#Dashboard {
  text-align: left;

  @include media-breakpoint-up(lg) {
    max-width: 90%;
    margin: 0 auto;
  }
}
.title {
  color: $samtek-black;
  font-size: 22px;
  font-weight: 700;
}
.breadcrumb-custom {
  margin-top: 8px;
  font-size: 15px;
  color: $samtek-grey;
}
.breadcrumb-custom .separator {
  margin: 0 6px;
}
</style>
